import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const SubscriptionPackageForm: React.FC<{ viewKey?: string, itemId?: number }> = ({ viewKey, itemId }) => {

    const apiObject = 'subscription_package';

    const disabledOnEdit = itemId ? true : false;

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'key',
            label: 'billing.subscription_package.key_label',
            type: 'text',
            placeholder: 'billing.subscription_package.key_placeholder',
            disabled: disabledOnEdit,
        },
        {
            name: 'name',
            label: 'billing.subscription_package.name_label',
            type: 'text',
            placeholder: 'billing.subscription_package.name_placeholder',
        },
        {
            name: 'explanation_nl',
            label: 'billing.subscription_package.explanation_text_label',
            type: 'textarea',
            rows: 2,
            placeholder: 'billing.subscription_package.explanation_text_placeholder',
        },
        {
            name: 'highlighted_features_nl',
            label: 'billing.subscription_package.highlighted_features_label',
            type: 'textarea',
            rows: 2,
            placeholder: 'billing.subscription_package.highlighted_features_placeholder',
        },
        {
            type: 'header',
            header: 'billing.subscription_package.pricing_header'
        },
        { 
            type: 'price', 
            name: 'yearly_price', 
            label: 'billing.subscription_package.yearly_price_label', 
            apiObject: 'currency',
            width: '50%',
            group: 'field-row-1',
            disabled: disabledOnEdit,
        },
        { 
            type: 'price', 
            name: 'monthly_price', 
            label: 'billing.subscription_package.monthly_price_label', 
            apiObject: 'currency',
            width: '50%',
            group: 'field-row-1',
            disabled: disabledOnEdit,
        },
        {
            type: 'header',
            header: 'billing.subscription_package.field_seats_header'
        },
        {
            name: 'enable_field_seats',
            label: 'billing.subscription_package.enable_field_seats_label',
            type: 'checkbox',
            // disabled: disabledOnEdit,
        },
        { 
            type: 'price', 
            name: 'yearly_field_price', 
            label: 'billing.subscription_package.yearly_field_price_label', 
            apiObject: 'currency',
            width: '50%',
            group: 'field-row-2',
            // disabled: disabledOnEdit,
        },
        { 
            type: 'price', 
            name: 'monthly_field_price', 
            label: 'billing.subscription_package.monthly_field_price_label', 
            apiObject: 'currency',
            width: '50%',
            group: 'field-row-2',
            // disabled: disabledOnEdit,
        },
        {
            type: 'header',
            header: 'billing.subscription_package.light_seats_header'
        },
        {
            name: 'enable_light_seats',
            label: 'billing.subscription_package.enable_light_seats_label',
            type: 'checkbox',
            disabled: disabledOnEdit,
        },
        { 
            type: 'price', 
            name: 'yearly_light_price', 
            label: 'billing.subscription_package.yearly_light_price_label', 
            apiObject: 'currency',
            width: '50%',
            group: 'field-row-3',
            dependentOn: { fieldName: 'enable_light_seats', value: true },
            disabled: disabledOnEdit,
        },
        { 
            type: 'price', 
            name: 'monthly_light_price', 
            label: 'billing.subscription_package.monthly_light_price_label', 
            apiObject: 'currency',
            width: '50%',
            group: 'field-row-3',
            dependentOn: { fieldName: 'enable_light_seats', value: true },
            disabled: disabledOnEdit,
        },
        {
            type: 'header',
            header: 'billing.subscription_package.seat_limit_header'
        },
        { 
            type: 'text', 
            name: 'seat_limit', 
            label: 'billing.subscription_package.seat_limit_label', 
            placeholder: 'billing.subscription_package.seat_limit_placeholder'
        },
        {
            type: 'header',
            header: 'billing.subscription_package.best_choice_header'
        },
        {
            name: 'is_best_choice',
            label: 'billing.subscription_package.best_choice_label',
            type: 'checkbox',
        },
        {
            type: 'header',
            header: 'billing.subscription_package.default_trial_package_header'
        },
        {
            name: 'is_default_trial_package',
            label: 'billing.subscription_package.default_trial_package_label',
            type: 'checkbox',
        },
        {
            type: 'header',
            header: 'billing.subscription_package.features_header',
            description: 'billing.subscription_package.features_description'
        },
        { 
            type: 'multiselect', 
            name: 'main_features',
            label: 'billing.subscription_package.main_features_label',
            apiObject: 'main_feature',
            disabled_selected: 'forms.select_type_disabled_selected',
            allowNoneOption: false,
            optionFormat: (option) => option.feature,
            selectionFormat: 'feature'
        },
        { 
            type: 'multiselect', 
            name: 'sub_features',
            label: 'billing.subscription_package.sub_features_label',
            apiObject: 'sub_feature',
            disabled_selected: 'forms.select_type_disabled_selected',
            allowNoneOption: false,
            optionFormat: (option) => option.feature,
            selectionFormat: 'feature'
        },
        { 
            type: 'multiselect', 
            name: 'modules',
            label: 'billing.subscription_package.modules_label',
            apiObject: 'total_feature',
            disabled_selected: 'forms.select_type_disabled_selected',
            allowNoneOption: false,
            optionFormat: (option) => option.feature,
            optionFilter: (option) => !option.is_integration && !option.is_api_tier,
            selectionFormat: 'feature'
        },
    ];

    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default SubscriptionPackageForm;